<template>
  <div class="NoticeBar" v-if="info.isad==1">
    <van-notice-bar left-icon="volume-o" scrollable  mode="closeable">{{info.adcontent}}</van-notice-bar>
  </div>
</template>

<script>
  export default {
    data(){
      return{
        info:JSON.parse(sessionStorage.getItem('info')),
      }
    },
  }
</script>

<style lang="less" scoped>
.NoticeBar{
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  max-width: 10rem;
  z-index: 99999;
  .van-notice-bar{
    background-color:rgba(0, 0, 0,.3);
    color: #fff;
  }
}
</style>